import apis from "../../../api";
import {
  getCityListAction,
  getClassesWithSurveryAction,
  getClassWiseUsageDeatilsAction,
  getCountryListAction,
  getDefaultShotClassInformationAction,
  getMobileAppInstallationCountAction,
  getMobileInstallationCountAction,
  getMobileInstallationTrendAction,
  getNoOfUserAccessedShotclassApplicationAction,
  getNoOfUserAccessedShotclassesAction,
  getProductCategoryListAction,
  getSearchClassNameAction,
  getShotclassCompletionTrendAction,
  getStateListAction,
  getSurveyReportAction,
  getTotalActiveUsersAction,
  getUserClassCompletionGraphReportAction,
  getUserDistributionReportAction,
  getUserGroupAccessDetailsAction,
  getUserGroupClassUsageDetailsAction,
  getUserVisualReportAction,
  getWorkOfficeListAction,
  sendRemainderAction,
  getAADApplicationReportReportCSV,
  getClassesWithScoredSurveryAction,
} from "../actionCreators/reportActionCreator";
import { getUserDistributionSummaryAction } from "../actionCreators/reportActionCreator";
import { getClassDistributionSummaryAction } from "../actionCreators/reportActionCreator";
import { getClassVisualReportAction } from "../actionCreators/reportActionCreator";
import { getTenantUsersAction } from "../actionCreators/reportActionCreator";
import { getTrainingTypesAction } from "../actionCreators/reportActionCreator";
import { getFilterUserDistributionSummaryAction } from "../actionCreators/reportActionCreator";
import { getFilterUserVisualReportAction } from "../actionCreators/reportActionCreator";
import { getFilterClassVisualReportAction } from "../actionCreators/reportActionCreator";
import { getFilterClassDistributionSummaryAction } from "../actionCreators/reportActionCreator";
import { getAssignedClassAction } from "../actionCreators/reportActionCreator";
import { getUserGroupAction } from "../actionCreators/reportActionCreator";
import moment from "moment";
import { getClassNameAction } from "../actionCreators/reportActionCreator";
import { getUserShotClassReportAction } from "../actionCreators/reportActionCreator";
import getCSVReport from "../../../api/reports/tabularReport/getCSVReport";
import getAccessReport from "../../../api/reports/accessReport/getAccessReport";
import { downloadFile } from "../../../utils/downloadFile";
import { setErrorAction } from "../actionCreators/errorActionCreator";

export const getUserVisualReportActionHandler = () => async (dispatch) => {
  await apis.reports.graphicalReports
    .getUserVisualReport()
    .then((response) => {
      dispatch(getUserVisualReportAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserDistributionSummaryActionHandler =
  () => async (dispatch) => {
    await apis.reports.graphicalReports
      .getUserDistributionSummary()
      .then((response) => {
        dispatch(getUserDistributionSummaryAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getClassDistributionSummaryActionHandler =
  () => async (dispatch) => {
    await apis.reports.graphicalReports
      .getClassDistributionSummary()
      .then((response) => {
        dispatch(getClassDistributionSummaryAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getClassVisualReportActionHandler = () => async (dispatch) => {
  await apis.reports.graphicalReports
    .getClassVisualReport()
    .then((response) => {
      dispatch(getClassVisualReportAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getTrainingTypesActionHandler = () => async (dispatch) => {
  await apis.reports.common
    .getTrainingTypes()
    .then((response) => {
      dispatch(getTrainingTypesAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAssignedClassActionHandler = () => async (dispatch) => {
  await apis.reports.graphicalReports
    .getAssignedClass()
    .then((response) => {
      dispatch(getAssignedClassAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getTenantUsersActionHandler = () => async (dispatch) => {
  await apis.reports.common
    .getTenantUsers()
    .then((response) => {
      dispatch(getTenantUsersAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getFilterUserDistributionSummaryActionHandler =
  (UserOrClassIds = [], TraingingTypeIds = [], Date) =>
  async (dispatch) => {
    const data = {
      UserOrClassIds: UserOrClassIds,
      TraingingTypeIds: TraingingTypeIds,
      Date: Date,
    };
    if (UserOrClassIds.length > 0) {
      await apis.reports.graphicalReports
        .getFilterUserDistributionSummary(data)
        .then((response) => {
          dispatch(getFilterUserDistributionSummaryAction(response.data));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getFilterUserVisualReportActionHandler =
  (UserOrClassIds = [], TraingingTypeIds = [], Date) =>
  async (dispatch) => {
    const data = {
      UserOrClassIds: UserOrClassIds,
      TraingingTypeIds: TraingingTypeIds,
      Date: Date,
    };
    if (UserOrClassIds.length > 0) {
      await apis.reports.graphicalReports
        .getFilterUserVisualReport(data)
        .then((response) => {
          dispatch(getFilterUserVisualReportAction(response.data));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getFilterClassDistributionSummaryActionHandler =
  (UserOrClassIds = [], TraingingTypeIds = [], Date) =>
  async (dispatch) => {
    const data = {
      UserOrClassIds: UserOrClassIds,
      TraingingTypeIds: TraingingTypeIds,
      Date: Date,
    };
    if (UserOrClassIds.length > 0) {
      await apis.reports.graphicalReports
        .getFilterClassDistributionSummary(data)
        .then((response) => {
          dispatch(getFilterClassDistributionSummaryAction(response.data));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getFilterClassVisualReportActionHandler =
  (UserOrClassIds = [], TraingingTypeIds = [], Date) =>
  async (dispatch) => {
    const data = {
      UserOrClassIds: UserOrClassIds,
      TraingingTypeIds: TraingingTypeIds,
      Date: Date,
    };
    if (UserOrClassIds.length > 0) {
      await apis.reports.graphicalReports
        .getFilterClassVisualReport(data)
        .then((response) => {
          dispatch(getFilterClassVisualReportAction(response.data));
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getUserGroupActionhandler = () => async (dispatch) => {
  await apis.reports.common
    .getUserGroup()
    .then((response) => {
      dispatch(getUserGroupAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getClassNameActionHandler = () => async (dispatch) => {
  await apis.reports.common
    .getClassName()
    .then((response) => {
      dispatch(getClassNameAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUserDistributionReportActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUserDistributionReport,
    setTempUserDistributionReport,
    setTotalRows,
    fromDate,
    toDate,
    user,
    trainingType = "none",
    reportMode,
    setLoader
  ) =>
  async () => {
    setLoader("true");
    if (reportMode === "View") {
      await apis.reports.tabularReport
        .getUserDistributionReport(
          fromDate,
          pageNumber,
          pageSize,
          reportMode,
          toDate,
          trainingType,
          user
        )
        .then((response) => {
          setUserDistributionReport((preStateData) => [
            ...preStateData,
            ...response.data.Content,
          ]);
          setTempUserDistributionReport((preStateData) => [
            ...preStateData,
            ...response.data.Content,
          ]);
          setTotalRows(response.data.TotalRows);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await apis.reports.tabularReport
        .getUserDistributionReport(
          fromDate,
          pageNumber,
          pageSize,
          reportMode,
          toDate,
          trainingType,
          user
        )
        .then((response) => {
          var utcMoment = moment.utc();
          var filename = "User Report_" + utcMoment.format("DMMMYYYY_hhmmss");
          getCSVReport(response, filename);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getClassDistributionReportActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setClassDistributionReport,
    setTempClassDistributionReport,
    setTotalRows,
    className,
    fromDate,
    toDate,
    trainingType,
    reportMode,
    setLoader
  ) =>
  async () => {
    // debugger;
    // setLoader(true);
    if (reportMode === "View") {
      await apis.reports.tabularReport
        .getClassDistributionReport(
          className,
          fromDate,
          pageNumber,
          pageSize,
          reportMode,
          toDate,
          trainingType
        )
        .then((response) => {
          setClassDistributionReport((preStateData) => [
            ...preStateData,
            ...response.data.Content,
          ]);
          setTempClassDistributionReport((preStateData) => [
            ...preStateData,
            ...response.data.Content,
          ]);
          setTotalRows(response.data.TotalRows);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await apis.reports.tabularReport
        .getClassDistributionReport(
          className,
          fromDate,
          pageNumber,
          pageSize,
          reportMode,
          toDate,
          trainingType
        )
        .then((response) => {
          var filename = "Class Report_" + moment().format("DMMMYYYY_hhmmss");
          getCSVReport(response, filename);
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getUserShotClassReportActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUserShotClassReport,
    setTempUserShotClassReport,
    setTotalRows,
    fromDate,
    reportMode,
    toDate,
    trainingType,
    userId
  ) =>
  async () => {
    {
      if (reportMode === "View") {
        await apis.reports.tabularReport
          .getUserShotClassReport(
            fromDate,
            pageNumber,
            pageSize,
            reportMode,
            toDate,
            trainingType,
            userId
          )
          .then((response) => {
            setUserShotClassReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTempUserShotClassReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTotalRows(response.data.length);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await apis.reports.tabularReport
          .getUserShotClassReport(
            fromDate,
            pageNumber,
            pageSize,
            reportMode,
            toDate,
            trainingType,
            userId
          )
          .then((response) => {
            var filename =
              "Detailed User Report_" + moment().format("DMMMYYYY_hhmmss");
            getCSVReport(response, filename);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

export const getShotClassUserReportActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setShotClassUserReport,
    setTempShotClassUserReport,
    setTotalRows,
    fromDate,
    reportMode,
    classId,
    toDate,
    trainingType
  ) =>
  async () => {
    {
      if (reportMode === "View") {
        await apis.reports.tabularReport
          .getShotClassUserReport(
            fromDate,
            pageNumber,
            pageSize,
            reportMode,
            classId,
            toDate,
            trainingType
          )
          .then((response) => {
            setShotClassUserReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTempShotClassUserReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTotalRows(response.data.length);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await apis.reports.tabularReport
          .getShotClassUserReport(
            fromDate,
            pageNumber,
            pageSize,
            reportMode,
            classId,
            toDate,
            trainingType
          )
          .then((response) => {
            var filename =
              "Detailed Class Report_" + moment().format("DMMMYYYY_hhmmss");
            getCSVReport(response, filename);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

export const getCountryListActionHandler = () => async (dispatch) => {
  await apis.reports.tabularReport
    .getCountryList()
    .then((response) => {
      if (response.data) {
        const updatedData = response.data.map((item) => {
          return { ...item, isChecked: false };
        });

        dispatch(getCountryListAction(updatedData));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getStateListActionHandler = (countryId) => async (dispatch) => {
  await apis.reports.tabularReport
    .getStateList(countryId)
    .then((response) => {
      if (response.data) {
        const updatedData = response.data.map((item) => {
          return { ...item, isChecked: false };
        });
        dispatch(getStateListAction(updatedData));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCityListActionHandler = (stateId) => async (dispatch) => {
  await apis.reports.tabularReport
    .getCityList(stateId)
    .then((response) => {
      if (response.data) {
        const updatedData = response.data.map((item) => {
          return { ...item, isChecked: false };
        });
        dispatch(getCityListAction(updatedData));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getProductCategoryListActionHandler = () => async (dispatch) => {
  await apis.reports.tabularReport
    .getProductCategoryList()
    .then((response) => {
      dispatch(getProductCategoryListAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getWorkOfficeListActionHandler = (cityId) => async (dispatch) => {
  await apis.reports.tabularReport
    .getWorkOfficeList(cityId)
    .then((response) => {
      if (response.data) {
        const updatedData = response.data.map((item) => {
          return { ...item, isChecked: false };
        });
        dispatch(getWorkOfficeListAction(updatedData));
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getUserClassCompletionAdvanceReportActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUserClassCompletionReport,
    setTempUserClassCompletionReport,
    setTotalRows,
    categoryId,
    cityId = 0,
    classId = 0,
    countryId = 0,
    fromDate,
    stateId = 0,
    toDate,
    workOfficeId = 0,
    trainingType = 0,
    userLoginId = "",
    userGroupId = 0
  ) =>
  async () => {
    {
      classId !== 0 &&
        (await apis.reports.tabularReport
          .getUserClassCompletionAdvanceReport(
            categoryId,
            cityId,
            classId,
            countryId,
            fromDate,
            (pageNumber = 1),
            (pageSize = 20),
            stateId,
            toDate,
            workOfficeId,
            trainingType,
            userLoginId,
            userGroupId
          )
          .then((response) => {
            setUserClassCompletionReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTempUserClassCompletionReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTotalRows(response.data.length);
          })
          .catch((err) => {
            console.log(err);
          }));
    }
  };

export const getUserReportActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUserClassCompletionReport,
    setTempUserClassCompletionReport,
    setTotalRows,
    categoryId,
    cityId = 0,
    classId = 0,
    countryId = 0,
    fromDate,
    stateId = 0,
    toDate,
    workOfficeId = 0,
    trainingType = 0,
    userId = 0,
    userGroupId = 0
  ) =>
  async () => {
    {
      userId !== 0 &&
        (await apis.reports.tabularReport
          .getUserReport(
            categoryId,
            cityId,
            classId,
            countryId,
            fromDate,
            (pageNumber = 1),
            (pageSize = 20),
            stateId,
            toDate,
            workOfficeId,
            trainingType,
            userId,
            userGroupId
          )
          .then((response) => {
            setUserClassCompletionReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTempUserClassCompletionReport((preStateData) => [
              ...preStateData,
              ...response.data,
            ]);
            setTotalRows(response.data.length);
          })
          .catch((err) => {
            console.log(err);
          }));
    }
  };

export const getUserClassCompletionGraphReportActionHandler =
  (
    categoryId,
    cityId = 0,
    classId = 0,
    countryId = 0,
    fromDate,
    pageNumber,
    pageSize,
    stateId = 0,
    toDate,
    workOfficeId = 0,
    trainingType = 0,
    userLoginId = "",
    userGroupId = 0
  ) =>
  async (dispatch) => {
    {
      classId !== 0 &&
        (await apis.reports.tabularReport
          .getUserClassCompletionGraphReport(
            categoryId,
            cityId,
            classId,
            countryId,
            fromDate,
            (pageNumber = 1),
            (pageSize = 20),
            stateId,
            toDate,
            workOfficeId,
            trainingType,
            userLoginId,
            userGroupId
          )
          .then((response) => {
            dispatch(getUserClassCompletionGraphReportAction(response.data));
          })
          .catch((err) => console.log(err)));
    }
  };

export const getClassesWithSurveryActionHandler = () => async (dispatch) => {
  await apis.reports.surveyReport
    .getClassesWithSurvey()
    .then((response) => {
      dispatch(getClassesWithSurveryAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSearchClassNameActionHandler =
  (ClassName, setState) => async (dispatch) => {
    await apis.reports.tabularReport
      .getSearchClassName(ClassName)
      .then((response) => {
        if (response.data) {
          setState(response.data.Content);
        } else {
          setState(response.data.Content);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getSearchUserGroupActionHandler =
  (userGroup, setState) => async (dispatch) => {
    await apis.reports.tabularReport
      .getSearchUserGroup(userGroup)
      .then((response) => {
        if (response.data) {
          // console.log(response.data.UserGroups, "========>");
          setState(response.data.UserGroups);
        } else {
          setState(response.data.UserGroups);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const sendRemainderActionHandler = (ClassId) => async (dispatch) => {
  await apis.reports.tabularReport
    .sendRemainder(ClassId)
    .then((response) => {
      dispatch(sendRemainderAction(response.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDefaultShotClassInformationActionHandler =
  () => async (dispatch) => {
    await apis.reports.analyticalReport
      .getDefaultShotClassInformation()
      .then((response) => {
        // console.log(response.data);
        dispatch(getDefaultShotClassInformationAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getQuizReportActionHanlder =
  (
    searchText,
    pageNumber,
    pageSize,
    setQuizReport,
    setTempQuizReport,
    setTotalRows,
    classNames,
    fromDate = "",
    toDate = "",
    userId = 0,
    groupId = "",
    reportMode,
    setReportActionLoader
  ) =>
  async () => {
    if (reportMode === "Extract") setReportActionLoader(false);
    else setReportActionLoader(true);
    if (reportMode === "View") {
      await apis.reports.quizReport
        .getQuizReport(
          classNames,
          fromDate,
          pageNumber,
          pageSize,
          toDate,
          userId,
          groupId,
          reportMode
        )
        .then((response) => {
          setQuizReport((preStateData) => [
            ...preStateData,
            ...response?.data?.Content,
          ]);
          setTempQuizReport((preStateData) => [
            ...preStateData,
            ...response?.data?.Content,
          ]);
          setTotalRows(response?.data?.TotalRows);
          setReportActionLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await apis.reports.quizReport
        .getQuizReport(
          classNames,
          fromDate,
          pageNumber,
          pageSize,
          toDate,
          userId,
          groupId,
          reportMode
        )
        .then((response) => {
          // setReportActionLoader(false);
          var filename =
            "QuizPerformanceReport_" + moment().format("DMMMYYYY_hhmmss");
          getCSVReport(response, filename);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

// export const getUserDistributionCSVReportActionHandler =
//   (
//     pageNumber,
//     pageSize,
//     fromDate = "none",
//     toDate = "none",
//     user = "none",
//     trainingType = "none",
//     reportMode
//   ) =>
//   async () => {
//     await apis.reports.tabularReport
//       .getUserDistributionCSVReport(
//         fromDate,
//         pageNumber,
//         pageSize,
//         reportMode,
//         toDate,
//         trainingType,
//         user
//       )
//       .then((response) => {
//         console.log(response.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };
export const getAccessReportActionHanlder =
  (
    searchText,
    pageNumber,
    pageSize,
    setAccessReport,
    setTempAccessReport,
    setTotalRows,
    fromDate,
    toDate,
    userId,
    groupId,
    timeZone = "UTC",
    reportMode
  ) =>
  async () => {
    const data = {
      EndDate: toDate,
      PageNum: pageNumber,
      PageSize: pageSize,
      StartDate: fromDate,
      Usergroups: groupId,
      timeZone: timeZone,
      userId: userId,
    };
    if (localStorage.getItem("SecurityProviderName").toLowerCase() !== "aad") {
      if (reportMode === "View") {
        await apis.reports.accessReport
          .getAccessReport(
            // fromDate,
            // (pageNumber = 1),
            // (pageSize = 20),
            // toDate,
            // userId,
            // groupId,
            // reportMode
            data
          )
          .then((response) => {
            setAccessReport((preStateData) => [
              ...preStateData,
              ...response.data.Content,
            ]);
            setTempAccessReport((preStateData) => [
              ...preStateData,
              ...response.data.Content,
            ]);
            setTotalRows(response.data.TotalRows);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await apis.reports.accessReport
          .getAccessReport(
            // fromDate,
            // (pageNumber = 1),
            // (pageSize = 20),
            // toDate,
            // userId,
            // groupId,
            // reportMode
            data
          )
          .then((response) => {
            var filename =
              "QuizPerformanceReport_" + moment().format("DMMMYYYY_hhmmss");
            getCSVReport(response, filename);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

export const getTotalActiveUserActionHandler =
  (fromDate, toDate, userGroupId) => async (dispatch) => {
    await apis.reports.adoptionReport
      .getTotalActiveUser(fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getTotalActiveUsersAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getMobileInstallationTrendActionHanlder =
  (classId = "none", fromDate, toDate, userGroupId) =>
  async (dispatch) => {
    // console.log(classId, "=-=-=-");
    await apis.reports.adoptionReport
      .getMobileInstallationTrend(classId, fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getMobileInstallationTrendAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getUserGroupAccessDetailsActionHandler =
  (classId = "none", fromDate, toDate, userGroupId) =>
  async (dispatch) => {
    await apis.reports.adoptionReport
      .getUserGroupAccessDetails(classId, fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getUserGroupAccessDetailsAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getUserGroupClassUsageDetailsActionHandler =
  (classId = "none", fromDate, toDate, userGroupId) =>
  async (dispatch) => {
    await apis.reports.adoptionReport
      .getUserGroupClassUsageDetails(classId, fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getUserGroupClassUsageDetailsAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getShotclassCompletionTrendActionHandler =
  (classId = "none", fromDate, toDate, userGroupId) =>
  async (dispatch) => {
    await apis.reports.adoptionReport
      .getShotclassCompletionTrend(classId, fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getShotclassCompletionTrendAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getClassWiseUsageDeatilsActionHandler =
  (classId = "none", fromDate, toDate, userGroupId) =>
  async (dispatch) => {
    await apis.reports.adoptionReport
      .getClassWiseUsageDeatils(classId, fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getClassWiseUsageDeatilsAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getNoOfUserAccessedShotclassApplicationActionHandler =
  (fromDate, toDate, userGroupId) => async (dispatch) => {
    await apis.reports.adoptionReport
      .getNoOfUserAccessedShotclassApplication(fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getNoOfUserAccessedShotclassApplicationAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getNoOfUserAccessedShotclassesActionHandler =
  (fromDate, toDate, userGroupId) => async (dispatch) => {
    await apis.reports.adoptionReport
      .getNoOfUserAccessedShotclassess(fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getNoOfUserAccessedShotclassesAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const GetMobileAppInstallationCountActionHandler =
  (fromDate, toDate, userGroupId) => async (dispatch) => {
    await apis.reports.adoptionReport
      .getMobileAppInstallationCount(fromDate, toDate, userGroupId)
      .then((response) => {
        dispatch(getMobileAppInstallationCountAction(response.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getDrillDownQuizReportActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setDrillDownQuizReport,
    setTempDrillDownQuizReport,
    setTotalRows,
    classId,
    reportMode,
    setQuestionData,
    setModalDataLoader
  ) =>
  async () => {
    if (reportMode === "Extract") setModalDataLoader(false);
    else setModalDataLoader(true);
    if (reportMode === "View") {
      await apis.reports.quizReport
        .getDrillDownQuizReport(
          classId,
          (pageNumber = 1),
          (pageSize = 20),
          reportMode
        )
        .then((response) => {
          setDrillDownQuizReport((preStateData) => [
            ...preStateData,
            ...response?.data?.Content?.QuestionList,
          ]);
          setTempDrillDownQuizReport((preStateData) => [
            ...preStateData,
            ...response?.data?.Content?.QuestionList,
          ]);
          setQuestionData([response?.data?.Content]);
          setTotalRows(response?.data?.TotalRows);
          setModalDataLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await apis.reports.quizReport
        .getDrillDownQuizReport(
          classId,
          (pageNumber = 0),
          (pageSize = 0),
          reportMode
        )
        .then((response) => {
          var filename =
            "ClassDrillDownReport_" + moment().format("DMMMYYYY_hhmmss");
          getCSVReport(response, filename);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getSurveyReportActionHandler =
  (classId, reportMode, className, template, surveyId) => async (dispatch) => {
    // await apis.reports.surveyReport
    //   .getSurveyReport(classId)
    //   .then((response) => {
    //     dispatch(getSurveyReportAction(response.data));
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // setReportLoader(true);
    if (reportMode === "View") {
      return await apis.reports.surveyReport
        .getSurveyReport(classId, reportMode)
        .then((response) => {
          dispatch(getSurveyReportAction(response.data));
          return response;
          // setReportLoader(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      return await apis.reports.surveyReport
        .getSurveyReport(classId, reportMode, template, surveyId)
        .then((response) => {
          if (surveyId) {
            const binaryData = response.data;
            const file = new Blob([binaryData], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const fileName = `Scored Survey Report_${moment().format(
              "DMMMYYYY_hhmmss"
            )}`;
            console.log(binaryData);
            const url = window.URL.createObjectURL(file);
            const downloadLink = document.createElement("a");
            downloadLink.href = url;
            downloadLink.download = fileName + ".xlsx";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            return file;
          } else {
            let filename = className + "_" + moment().format("DMMMYYYY_hhmmss");
            getCSVReport(response, filename);
            return response;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

export const getApplicationAccessUserDetailsActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setApplicationAccessUserDetails,
    setTempApplicationAccessUserDetails,
    setTotalRows,
    userId,
    fromDate,
    toDate,
    timeZone,
    reportMode
  ) =>
  async () => {
    if (localStorage.getItem("SecurityProviderName").toLowerCase() !== "aad") {
      if (reportMode === "View") {
        await apis.reports.accessReport
          .getApplicationAccessUserDetails(
            userId,
            fromDate,
            toDate,
            timeZone,
            reportMode
          )
          .then((response) => {
            setApplicationAccessUserDetails((preStateData) => [
              ...preStateData,
              ...response?.data?.Content,
            ]);
            setTempApplicationAccessUserDetails((preStateData) => [
              ...preStateData,
              ...response?.data?.Content,
            ]);
            setTotalRows(response?.data?.TotalRows);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        await apis.reports.accessReport
          .getApplicationAccessUserDetails(
            userId,
            fromDate,
            toDate,
            timeZone,
            reportMode
          )
          .then((response) => {
            var filename =
              "ClassDrillDownReport" + moment().format("DMMMYYYY_hhmmss");
            getCSVReport(response, filename);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

export const getUserResponseToQuestionActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setUserResponseToQuestionsReport,
    setTempUserResponseToQuestionsReport,
    setTotalRows,
    questionID,
    filterParam,
    userName,
    setChoiceList
  ) =>
  async () => {
    {
      await apis.reports.quizReport
        .getUserResponseToQuestion(
          questionID,
          pageNumber,
          pageSize,
          filterParam,
          userName
        )
        .then((response) => {
          setUserResponseToQuestionsReport(response?.data);
          setTempUserResponseToQuestionsReport(response?.data);
          setChoiceList(response?.data?.SelectedQuestion?.ChoiceList);
          setTotalRows(response?.data?.length);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

//harshil
export const getComprehensiveReportCSVActionHandler =
  (
    userId,
    usergroupId,
    classId,
    trainingTypeId,
    categoryId,
    fromDate,
    toDate,
    countryId,
    stateId,
    cityId,
    storeId
  ) =>
  async () => {
    return await apis.reports.tabularReport
      .getComprehensiveReportCSV(
        userId,
        usergroupId,
        classId,
        trainingTypeId,
        categoryId,
        fromDate,
        toDate,
        countryId,
        stateId,
        cityId,
        storeId
      )
      .then((response) => {
        const fileName = `User Report Advanced_${moment().format(
          "DMMMYYYY_hhmmss"
        )}`;
        downloadFile(response.data, fileName);
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getTabularReportCSVActionHandler =
  (
    userId,
    usergroupId,
    classId,
    trainingTypeId,
    categoryId,
    fromDate,
    toDate,
    countryId,
    stateId,
    cityId,
    storeId
  ) =>
  async () => {
    return await apis.reports.tabularReport
      .getTabularReportCSV(
        userId,
        usergroupId,
        classId,
        trainingTypeId,
        categoryId,
        fromDate,
        toDate,
        countryId,
        stateId,
        cityId,
        storeId
      )
      .then((response) => {
        const fileName = `User Report Advanced_${moment().format(
          "DMMMYYYY_hhmmss"
        )}`;
        downloadFile(response.data, fileName);
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getAccessReportCSVActionHandler =
  (userId, usergroupId, timeZone, fromDate, toDate) => async () => {
    return await apis.reports.accessReport
      .getAccessReportCSV(usergroupId, timeZone, fromDate, toDate, userId)
      .then((response) => {
        const fileName = `Export_${moment().format("DMMMYYYY_hhmmss")}`;
        downloadFile(response.data, fileName);
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getAccessDetailedReportCSVActionHandler =
  (userId, usergroupId, timeZone, fromDate, toDate) => async () => {
    return await apis.reports.accessReport
      .getAccessDetailedReportCSV(
        usergroupId,
        timeZone,
        fromDate,
        toDate,
        userId
      )
      .then((response) => {
        const fileName = `Export_${moment().format("DMMMYYYY_hhmmss")}`;
        downloadFile(response.data, fileName);
        return response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getAADApplicationReportActionHandler =
  (data, setAadAccessReportData) => async () => {
    setAadAccessReportData([]);
    return await apis.reports.accessReport
      .getAADApplicationReport(data)
      .then((response) => {
        if (response?.status === 200) setAadAccessReportData(response.data);
        return response?.data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getAADUserAccessDetailsReportActionHandler =
  (loginId, startDate, endDate, setAadUserAccessDetailsReport) => async () => {
    await apis.reports.accessReport
      .getAADUserAccessDetailsReport(loginId, startDate, endDate)
      .then((response) => {
        if (response?.status === 200)
          setAadUserAccessDetailsReport(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getAADApplicationReportCSVHandler =
  (userId, usergroupId, fromDate, toDate) => async () => {
    await apis.reports.accessReport
      .getAADApplicationReportCSV(userId, usergroupId, fromDate, toDate)
      .then((response) => {
        if (response) {
          console.log(response);
          const fileName = `Export_${moment().format("DMMMYYYY_hhmmss")}`;
          downloadFile(response.data, fileName);
          return response.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getAADUserAccessDetailReportCSVActionHandler =
  (url) => async () => {
    debugger;
    await apis.reports.accessReport
      .getAADUserAccessDetailReportCSV(url)
      .then((response) => {
        if (response) {
          console.log(response);
          const fileName = `Export_${moment().format("DMMMYYYY_hhmmss")}`;
          downloadFile(response.data, fileName);
          return response.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
export const getScoredSurveyReportActionHandler =
  (isScoredSurvey) => async (dispatch) => {
    await apis.reports.surveyReport
      .getClassesWithSurvey(isScoredSurvey)
      .then((response) => {
        if (response) {
          dispatch(getClassesWithScoredSurveryAction(response.data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
